import { render, staticRenderFns } from "./SidebarAddTodo.vue?vue&type=template&id=40169b4f&scoped=true&"
import script from "./SidebarAddTodo.vue?vue&type=script&lang=js&"
export * from "./SidebarAddTodo.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=40169b4f&prod&scoped=true&lang=css&"
import style1 from "./SidebarAddTodo.vue?vue&type=style&index=1&id=40169b4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40169b4f",
  null
  
)

export default component.exports